import { Paper, Typography } from "@mui/material";

export default function MapBandModal({ selectedRegion }) {
  return (
    <Paper variant="map-popup">
      <Typography
        variant="h5"
        component="p"
        className="location-name"
        sx={{ textTransform: "initial" }}
      >
        {selectedRegion.region.name}
      </Typography>
      <Typography variant="body1" className="band-totalcount">
        Gesamtanzahl:{" "}
        <span className="font-bold">
          {selectedRegion.region.popboard_bands?.filter(
            (b) =>
              b.display_on_map === true ||
              b.source === "popboard" ||
              b.source === null,
          ).length ?? 0}
        </span>
      </Typography>
      <Typography variant="body1" className="band-text">
        Bands:{" "}
        <span className="font-bold">
          {selectedRegion.region.popboard_bands?.filter(
            (b) =>
              (b.type === "band" && b.display_on_map === true) ||
              b.source === "popboard" ||
              b.source === null,
          ).length ?? 0}
        </span>
      </Typography>
      <Typography variant="body1" className="band-text">
        Solo Künstler*innen:{" "}
        <span className="font-bold">
          {selectedRegion.region.popboard_bands?.filter(
            (b) =>
              (b.type === "solo" && b.display_on_map === true) ||
              b.source === "popboard" ||
              b.source === null,
          ).length ?? 0}
        </span>
      </Typography>
    </Paper>
  );
}
